import { isDefined } from "@clipboard-health/util-ts";
import { type Shift, shiftPeriodToTimeSlot } from "@src/appV2/Shifts/Shift/types";
import { type ReactNode } from "react";

import { ShiftWithContentCard } from "../../Shift/Card/CardWithContent";
import { getFormattedShiftPayBreakdown } from "../../Shift/getFormattedShiftPayBreakdown";
import { getShiftWorkDurationInHours } from "../../utils/getShiftWorkDuration";

interface UnverifiedShiftCardWithBreakConfigProps {
  shift: Shift;
  children: ReactNode;
}

export function UnverifiedShiftCardWithBreakConfig({
  shift,
  children,
}: UnverifiedShiftCardWithBreakConfigProps) {
  const requiresBreak =
    (shift.facility.requiresLunchBreak ?? false) && isDefined(shift.breakPolicy);
  const mandatoryBreakDurationInMinutes = requiresBreak
    ? (shift.breakPolicy?.breakDurationInMinutes ?? 0)
    : 0;

  const shiftPayBreakdown = getFormattedShiftPayBreakdown(
    shift.offer?.pay.value,
    shift.finalPay,
    shift.originalAmount
  );

  const shiftWorkDurationInHours = getShiftWorkDurationInHours(
    shift,
    requiresBreak,
    mandatoryBreakDurationInMinutes
  );

  return (
    <ShiftWithContentCard
      shiftTimeSlot={shiftPeriodToTimeSlot[shift.name]}
      shiftStart={shift.start}
      shiftEnd={shift.end}
      shiftQualificationName={shift.agentReq}
      shiftHourlyPay={shiftPayBreakdown?.hourlyPay}
      shiftTotalPay={shiftPayBreakdown?.totalPay}
      shiftWorkDurationInHours={shiftWorkDurationInHours}
      workplaceName={shift.facility.name}
      workplaceTimezone={shift.facility.tmz ?? ""}
    >
      {children}
    </ShiftWithContentCard>
  );
}
